import React, { Component, Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { ExclamationIcon } from '@heroicons/react/outline'

class ConfirmDialog extends Component {
	render() {
		const cancelButtonRef = React.createRef()
		const confirmLabel = this.props.confirmLabel || 'Confirmer'
		const cancelLabel = this.props.cancelLabel || 'Annuler'
		return (
			<Transition.Root show={this.props.open === true} as={Fragment}>
				<Dialog as="div" className="fixed z-50 inset-0 overflow-y-auto" initialFocus={cancelButtonRef} onClose={this.props.onCancel}>
					<div className="flex items-center justify-center min-h-screen p-4">
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0"
							enterTo="opacity-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100"
							leaveTo="opacity-0"
						>
							<Dialog.Overlay className="fixed inset-0 bg-slate-900 bg-opacity-40 transition-opacity" />
						</Transition.Child>
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0 translate-y-4 sm:scale-95"
							enterTo="opacity-100 translate-y-0 sm:scale-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100 translate-y-0 sm:scale-100"
							leaveTo="opacity-0 translate-y-4 sm:scale-95"
						>
							<div className="relative bg-white rounded-2xl border border-slate-200 shadow-xl text-left overflow-hidden max-w-md w-full p-6 transform transition-all">
								<div className="flex items-start gap-4">
									<div className="w-10 h-10 rounded-xl bg-amber-50 flex items-center justify-center flex-shrink-0">
										<ExclamationIcon className="w-5 h-5 text-amber-600" aria-hidden="true" />
									</div>
									<div className="flex-1 min-w-0">
										<Dialog.Title as="h3" className="text-base font-black text-slate-900 my-0 leading-snug">
											{this.props.title}
										</Dialog.Title>
										<p className="text-sm font-medium text-slate-500 mt-1.5 mb-0">{this.props.message}</p>
									</div>
								</div>
								<div className="mt-6 flex justify-end gap-2">
									<button
										type="button"
										ref={cancelButtonRef}
										onClick={this.props.onCancel}
										className="inline-flex items-center px-4 py-2.5 text-2xs font-black uppercase tracking-widest rounded-xl border border-slate-200 text-slate-600 cursor-pointer transition-all active:scale-95 focus:outline-none focus:ring-2 focus:ring-indigo-500"
										style={{ backgroundImage: 'none', backgroundColor: '#ffffff' }}
										onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f8fafc' }}
										onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#ffffff' }}
									>
										{cancelLabel}
									</button>
									<button
										type="button"
										onClick={this.props.onConfirm}
										className="inline-flex items-center px-4 py-2.5 text-2xs font-black uppercase tracking-widest rounded-xl shadow-sm text-white cursor-pointer transition-all active:scale-95 focus:outline-none focus:ring-2 focus:ring-indigo-500"
										style={{ backgroundImage: 'none', backgroundColor: '#4f46e5' }}
										onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#4338ca' }}
										onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#4f46e5' }}
									>
										{confirmLabel}
									</button>
								</div>
							</div>
						</Transition.Child>
					</div>
				</Dialog>
			</Transition.Root>
		)
	}
}

export default ConfirmDialog
